import React, { useState } from "react"
import { createPortal } from "react-dom"
import { MdOutlinePictureAsPdf } from "react-icons/md"
import { toast } from "react-toastify"
import Button from "../../components/Form/Button"
import { generateDashboardPdf } from "../../utils/dashboardPdf"
import styles from "./dashboard.module.css"

const PdfExportButton = ({ title, accountName, generatedBy, filters, data, buildReport, disabled = false, fullWidth = true, size = "md", label = "Gerar PDF" }) => {
    const [exporting, setExporting] = useState(false)
    const [progress, setProgress] = useState(0)

    const exportPdf = async () => {
        if (disabled || exporting) return
        try {
            setExporting(true)
            setProgress(2)
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)))
            const preparedReport = buildReport ? await buildReport() : {}
            await generateDashboardPdf({
                title,
                accountName,
                generatedBy,
                filters,
                data,
                ...preparedReport,
                onProgress: setProgress,
            })
            toast.success("Relatório PDF gerado com sucesso.")
        } catch (error) {
            toast.error("Não foi possível gerar o relatório PDF.")
        } finally {
            setExporting(false)
            setProgress(0)
        }
    }

    return (
        <>
            <Button
                type="button"
                className={styles.pdfExportButton}
                fullWidth={fullWidth}
                size={size}
                onClick={exportPdf}
                disabled={disabled || exporting}
                title={disabled ? "Aplique os filtros para gerar o relatório" : "Gerar relatório PDF"}
            >
                <MdOutlinePictureAsPdf />
                <span>{exporting ? `Gerando ${progress}%` : label}</span>
            </Button>
            {exporting && createPortal((
                <div className={styles.pdfProgressOverlay} role="status" aria-live="polite">
                    <div className={styles.pdfProgressCard}>
                        <MdOutlinePictureAsPdf />
                        <strong>Preparando seu relatório</strong>
                        <span>Processando gráficos e organizando as páginas…</span>
                        <div
                            className={styles.pdfProgressTrack}
                            role="progressbar"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            aria-valuenow={progress}
                        >
                            <div className={styles.pdfProgressBar} style={{ width: `${progress}%` }} />
                        </div>
                        <b>{progress}%</b>
                    </div>
                </div>
            ), document.body)}
        </>
    )
}

export default PdfExportButton
